import { ConsoleLogger } from './console-logger';
import { OtlpLogger } from './otlp-logger';
import type { ILogger, OnErrorLogged } from './types';

interface CreateLoggerOptions {
  serviceName: string;
  isOpenTelemetryEnabled: boolean;
  onErrorLogged?: OnErrorLogged;
}

// OtlpLogger's constructor calls logs.getLogger(...), which requires the global
// LoggerProvider registered by initializeOtelLogging(). Callers must call
// initializeOtelLogging() before creating an OTLP logger — don't reorder.
export const createLogger = ({ serviceName, isOpenTelemetryEnabled, onErrorLogged }: CreateLoggerOptions): ILogger =>
  isOpenTelemetryEnabled ? new OtlpLogger({ serviceName, onErrorLogged }) : new ConsoleLogger({ onErrorLogged });
